import cx from 'classnames'
import React, { FC } from 'react'
import RadioFilter from './RadioFilter'
import { HeartIcon } from 'icons'

type FavoriteToggleProps = {
  expanded?: boolean
  isActive: boolean
  onToggle: () => void
}

const FavoriteToggle: FC<FavoriteToggleProps> = ({
  isActive,
  expanded,
  onToggle,
}) => {
  return expanded ? (
    <div className="space-y-16">
      <fieldset>
        <legend id="favorites-filter" className="util-label">
          Favorites
        </legend>
        <RadioFilter
          ariaLabelledBy="favorites-filter"
          className="mt-8"
          items={[
            {
              value: 0,
              label: 'All',
            },
            {
              value: 1,
              label: 'Favorites',
              component: React.createElement(HeartIcon, {
                'aria-hidden': true,
                className: `${
                  isActive ? 'stroke-white' : 'stroke-teal-3'
                } rect-22`,
                style: { display: 'inline' },
              }),
            },
          ]}
          selectedValue={isActive ? 1 : 0}
          onValueChange={onToggle}
        />
      </fieldset>
    </div>
  ) : (
    <div>
      <button
        className={cx(
          'rounded-sm px-14 py-12 font-semibold leading-snug ring-1 ring-grey-3',
          'focus:ring-teal-3',
          'state-open:bg-teal-1 state-open:text-teal-3 state-open:ring-teal-3',
          {
            'bg-white text-teal-3 hover:bg-teal-1 hover:ring-teal-3': !isActive,
            'bg-teal-3 text-white ring-teal-3': isActive,
          }
        )}
        onClick={onToggle}
      >
        <span className="sr-only">Filter Listings</span>
        <HeartIcon
          aria-hidden="true"
          className={`${
            isActive ? 'fill-white stroke-white' : 'stroke-teal-3'
          } rect-22`}
        />
      </button>
    </div>
  )
}

export default FavoriteToggle
